var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card m-3 shadow"},[_c('div',{staticClass:"card-header"},[_c('div',{staticClass:"d-flex"},[_c('div',{staticClass:"flex-fill"},[_c('SearchUser')],1),_c('div',{staticClass:"float-end"},[_c('PaginationUser')],1)])]),_c('div',{staticClass:"card-body"},[_c('TableUser')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }